<div class="ignite-toolbar-container">
  <div class="ignite-toolbar">
    <div class="toolbar-wrapper">
      <div class="toolbar-items">
        <img id="pearsonLogo" src="assets/images/PEARSON_LOGO_WHITE_RGB.svg" (click)="goHome()" alt="Pearson PTE" />
        @if (firstName || lastName) {
          <div class="user-profile-menu-container">
            <ignite-profile-menu [firstName]="firstName" [lastName]="lastName" [menuOptions]="profileOptions"></ignite-profile-menu>
          </div>
        }
      </div>
    </div>
  </div>
</div>
